
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from 'vuex'
import { key } from '@/vue/store'

export default defineComponent({
  name: 'VButton',
  props: {
    href: {
      type: String as PropType<string>,
      required: true,
    },
    currentTab: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const store = useStore(key)
    const utm = computed(() => store.state.userUtm)
    const link = computed(() => {
      let l: string = props.href
      if (utm.value) {
        l += l.includes('?') ? '&' : '?'
        l += utm.value.replace(/^\?/, '')
      }
      return l
    })
    return { link }
  },
})
